// Strand's icon mark: the six data points every address carries, threaded
// together, with the sixth standing proud in teal as the record itself.
// It says what Strand is — scattered facts about a building pulled onto
// one thread and signed off — without falling back on the building-and-
// tick that every compliance product already uses.
//
// It degrades well: at 20px the threads fade into the grid and it reads
// as a clean six-dot mark; at 96px the connections show.
//
// Drawn inline rather than loaded from /logo.svg so it inherits theme
// colours and stays crisp at any size without a second request. Keep it
// in sync with public/logo.svg, which is the same mark for <img>, Open
// Graph and the schema.org logo field.

type Props = {
  /** Rendered width and height in px. */
  size?: number;
  className?: string;
};

const BrandMark = ({ size = 28, className }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <rect width="28" height="28" rx="8" fill="var(--brand-mark-tile, #1A1A17)" />

    {/* The thread. Sits under the points so it reads as something they
        are strung on rather than lines drawn between them. */}
    <path
      d="M10 8.5h8M10 14h8M10 19.5h8"
      stroke="var(--brand-mark-badge, #007979)"
      strokeWidth="1.5"
      strokeLinecap="round"
      opacity="0.6"
    />

    <g fill="var(--brand-mark-glyph, #FFFFFF)">
      <circle cx="10" cy="8.5" r="1.9" />
      <circle cx="18" cy="8.5" r="1.9" />
      <circle cx="10" cy="14" r="1.9" />
      <circle cx="18" cy="14" r="1.9" />
      <circle cx="10" cy="19.5" r="1.9" />
    </g>

    {/* The sixth point: the signed-off record the other five resolve to. */}
    <circle cx="18" cy="19.5" r="2.5" fill="var(--brand-mark-badge, #007979)" />
  </svg>
);

export default BrandMark;
